var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { baseFetch } from "../../utility/api";
import { handleResponse } from "../../utility/api/handleResponse";
import { normalizeData } from "../utils";
/**
 * Gets the Customer Domain from a fetch
 *
 * @param access_token Access token needed for authorization
 * @param environment Environment needed to perform a base fetch
 * @returns Customer Domain from response
 */
export function get(_a) {
    return __awaiter(this, arguments, void 0, function* ({ access_token, environment, }) {
        const fetcher = baseFetch({ environment });
        const response = yield fetcher("/acs/v3/customers/self?addFields=etin", {
            headers: { Authorization: `Bearer ${access_token}` },
        });
        const json = yield handleResponse(response);
        return normalizeData(json);
    });
}
/**
 * Patches the Customer Domain from a fetch
 * @param access_token Access token needed for authorization
 * @param environment Environment needed to perform a base fetch
 * @param payload Customer payload to send in fetch body
 * @returns Customer Domain from response
 */
export function patch(_a) {
    return __awaiter(this, arguments, void 0, function* ({ access_token, environment, payload, }) {
        const fetcher = baseFetch({ environment });
        const response = yield fetcher("/acs/v3/customers/self", {
            headers: { Authorization: `Bearer ${access_token}` },
            method: "PATCH",
            body: JSON.stringify(payload),
        });
        const json = yield handleResponse(response);
        return normalizeData(json);
    });
}
/**
 * Patches the Auto Customer Domain from a fetch
 * @param access_token Access token needed for authorization
 * @param environment Environment needed to perform a base fetch
 * @param payload Auto Customer payload to send in fetch body
 * @param additionalHeaders optional parameter - additional headers to be added to patch call
 * Ex: Headers from mobile code
 *    {
 *      ApplicationId: 'ALLYUSBOLB',
 *      ApplicationName: 'AOB',
 *      ApplicationVersion: '1.0',
 *      Referer: 'https://secure-qa1.ally.com',
 *    }
 * @returns Customer Domain from response
 */
export function patchAuto(_a, additionalHeaders_1) {
    return __awaiter(this, arguments, void 0, function* ({ access_token, environment, payload }, additionalHeaders) {
        const fetcher = baseFetch({ environment });
        const response = yield fetcher("/acs/v3/customers/auto/self", {
            headers: Object.assign({ Authorization: `Bearer ${access_token}` }, additionalHeaders),
            method: "PATCH",
            body: JSON.stringify(payload),
        });
        const json = yield handleResponse(response);
        return normalizeData(json);
    });
}
//# sourceMappingURL=index.js.map